import i18n from 'i18n';

import { IRule } from './types';

export class DotCheckAtTheEnd implements IRule {

	passes(value: string): boolean {
		if (!value) return true;
		return !value.endsWith('.');
	}

	message(): string {
		return i18n.t('validation:dotCheckAtTheEnd');
	}
}
